import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSmsProps } from './IconSms.types'
import * as Styled from './styles/IconSms.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSms: FC<IconSmsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSmsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSmsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M115.89 70.61V54a18 18 0 0 0-18-18H38.31a18 18 0 0 0-18 18l.09 40a18 18 0 0 0 18 18h5.91v20.85L64.39 112h11.93'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <path
          d='M172.11 129.85a18 18 0 0 1-18 18h-5.71v20.85l-20.09-20.85h-34c-10 0-18-8.06-18-18.56v-40c0-9.38 8-17.44 18-17.44'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <path d='M94.32 71.88h77.79v57.97' fill='none' vectorEffect='non-scaling-stroke' />
        <circle cx='125' cy='112.56' fill='none' r='3.35' vectorEffect='non-scaling-stroke' />
        <circle cx='125' cy='112.56' fill='none' r='1' vectorEffect='non-scaling-stroke' />
        <circle cx='149' cy='112.56' fill='none' r='3.35' vectorEffect='non-scaling-stroke' />
        <circle cx='149' cy='112.56' fill='none' r='1' vectorEffect='non-scaling-stroke' />
        <circle cx='100.91' cy='112.56' fill='none' r='3.35' vectorEffect='non-scaling-stroke' />
        <circle cx='100.91' cy='112.56' fill='none' r='1' vectorEffect='non-scaling-stroke' />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSms
